// extracted by mini-css-extract-plugin
export default {"box":"index_box_54ZyS","title":"index_title_-2WI5","line":"index_line_tQecw","coor":"index_coor_Ry88V","item_box":"index_item_box_jkHc0"};